import { defineComponent as _defineComponent } from 'vue'
import _ from 'lodash'
import MainTitle from '@/components/MainTitle/MainTitle.vue'
import MainMenu from '@/components/MainMenu/MainMenu.vue'
import { makeMainMenuItems } from './constants/menu'
import { IUserMenu } from './api/moudules/system.types'
import BrowerTitle from './components/BrowerTitle.vue'
import EigenvalueShow from './popup/EigenvalueShow.vue'
import AlarmPopupList from '@/popup/AlarmPopupList/AlarmPopupList.vue'
import AiChatDialog from '@/components/AiChatDialog/AiChatDialog.vue'
import qs from 'qs'
import { collectSubRoutes, IMenuItem, } from './view_helper/mainMenu'
import { E_RouterNames } from './router/types'
import { computed, getCurrentInstance, watch, ref } from 'vue'
import { useRoute } from 'vue-router/composables'
import { useStore } from './hooks/useStore'
import { useI18n } from './hooks/useI18n'
import { filterMenus } from './view_helper/app'
import { provideAppMenuClickHandler, useAppEigenvalProvider, useAppFechAlarmCountLoop, useAppNotices } from './hooks/useApp'
import { useAi } from './hooks/useAi'
import AiHelper from './components/AiHelper.vue'
import Breadcrumb from './components/Breadcrumb/Breadcrumb.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()

const instance = getCurrentInstance()
const {
    $t,
} = useI18n()
const ShowLayoutComponents = computed(() => {
    const {
        name,
        meta,
    } = route
    if (_.isNil(name)) {
        return false
    }
    if (meta?.noMainLayoutComponent) {
        return false
    }
    return true
})

const {
    store
} = useStore()

const gMenus = computed(() => {
    return store.state.menus as IUserMenu[]
})
const isSuperAdmin = computed(() => {
    return store.getters.isSuperAdmin as boolean
})
const isCompanyAdmin = computed(() => {
    return store.getters.isAdmin as boolean
})
const hasLogin = computed(() => {
    return store.getters.hasLogin as boolean
})
const menuPermissionsLoaded = computed(() => {
    return store.state.menuPermissionsLoaded as boolean
})
const loading = computed(() => {
    return store.state.loading as boolean
})

const MainMenuItems = computed(() => {
    const vm = instance.proxy
    let mainMenuItems = makeMainMenuItems(instance.proxy)
    mainMenuItems = filterMenus(vm, isSuperAdmin.value, isCompanyAdmin.value, mainMenuItems, gMenus.value)
    let res = _.map(mainMenuItems, menuItem => {
        const routerSet = collectSubRoutes(menuItem)
        return {
            ...menuItem,
            isActive: _.some(route.matched, x => routerSet.has(x.name) || routerSet.has(x.meta?.parentName))
        }
    })
    console.log({ menu: res })
    return res
})
const IsManagement = computed(() => {
    const isConfigureManager = _.some(route.matched, x => x.name === 'configureManagement')
    const isMenuManagement = _.includes(['customerManagement_menu'], route.name)
    const isDeviceScreen = _.includes(['deviceScreen', 'deviceScreenEdit'], route.name)
    return (isConfigureManager || isMenuManagement) && !isDeviceScreen
})

const IsWaveSpectrum = computed(() => {
    const isWaveSpectrum = route.name === 'waveSpectrum'
    return isWaveSpectrum
})

const IsLargeScreen = computed(() => {
    const isLargeScreen = [
        E_RouterNames.largeScreen2,
        E_RouterNames.largeScreenAdmin,
        E_RouterNames.largeScreenLegacyExt,
        E_RouterNames.largeScreenLegacyNormal,
        E_RouterNames.largeScreenNormal,
        E_RouterNames.largeScreenCompany,
    ].includes(route.name as any)
    return isLargeScreen
})

const IsPortal = computed(() => route.name === E_RouterNames.platformPortal)

const ShowRouterViewPadding = computed(() => {
    return ShowLayoutComponents.value && !IsLargeScreen.value
})

const {
    showEigenvalue,
    onCloseEigenvalue,
    eigenvalue,
    eigenvalueType,
} = useAppEigenvalProvider()

const needScheduleFetchAlarm = computed(() => {
    const isBusinessRoute = Boolean(route.name) && ![
        E_RouterNames.login,
        E_RouterNames.platformPortal,
    ].includes(route.name as E_RouterNames)
    return hasLogin.value
        && menuPermissionsLoaded.value
        && !isSuperAdmin.value
        && isBusinessRoute
})

const {
    fetchNoticeQuery,
} = useAppNotices()

const {
    showAlarmPopupList,
    fetchAlaramCount,
    onAlarmPopupClose,
    closeAlarmNotify,
    alarmAudioPlayerRef,
    showAlarmAudioPlayer,
} = useAppFechAlarmCountLoop(needScheduleFetchAlarm)
const alarmAudioPlayerMinimized = ref(false)

watch(showAlarmAudioPlayer, (visible) => {
    if (!visible) {
        alarmAudioPlayerMinimized.value = false
    }
})

const {
    aiHelperRef,
    openAiChat,
    onCloseAiChat,
    showAIHelper,
    aiChatDialogVisible,

    aiHelperState,
    onUpdateAiHelperState,

    onAiMenuClick,
} = useAi(hasLogin)

function onMenuClick(item: IMenuItem) {
    if(item.permission === 'system:aiHelper')    {
        onAiMenuClick()
    }
}

provideAppMenuClickHandler(onMenuClick)

watch(() => route.name, value => {
    if(value === E_RouterNames.login) {
        closeAlarmNotify()
        onAlarmPopupClose()
    }
})

watch(needScheduleFetchAlarm, (needSchedule) => {
    if (needSchedule) {
        fetchNoticeQuery()
        const searchList = qs.parse(location.search, {
            ignoreQueryPrefix: true,
        })
        if (!_.has(searchList, 'delayFetchAlaramCount')) {
            fetchAlaramCount()
        }
    }
}, { immediate: true })


return { __sfc: true,route, instance, $t, ShowLayoutComponents, store, gMenus, isSuperAdmin, isCompanyAdmin, hasLogin, menuPermissionsLoaded, loading, MainMenuItems, IsManagement, IsWaveSpectrum, IsLargeScreen, IsPortal, ShowRouterViewPadding, showEigenvalue, onCloseEigenvalue, eigenvalue, eigenvalueType, needScheduleFetchAlarm, fetchNoticeQuery, showAlarmPopupList, fetchAlaramCount, onAlarmPopupClose, closeAlarmNotify, alarmAudioPlayerRef, showAlarmAudioPlayer, alarmAudioPlayerMinimized, aiHelperRef, openAiChat, onCloseAiChat, showAIHelper, aiChatDialogVisible, aiHelperState, onUpdateAiHelperState, onAiMenuClick, onMenuClick, MainTitle, MainMenu, BrowerTitle, EigenvalueShow, AlarmPopupList, AiChatDialog, AiHelper, Breadcrumb }
}

})